import React from 'react'
import { observable, action, toJS, computed, makeObservable, runInAction } from 'mobx'
import api from '../service/api'
import AuthStore from './auth.store'
import NotificationStore from './notification.store'

class UserStore {

    user // Logged In Json Info
    userAccounts
    userDebug
    errorsStatuses

    constructor () {
        this.user = { "user_name": "", "user_id": "", "user_email": "", "user_org_code": "", "user_dept_code": "", "user_role": "", "user_auditor": false }
        this.api = api
        this.userDebug = {}
        this.userAccounts = []
        this.userSubjects = {
            years: [],
            semesters: [],
            allSubjects: [],
            academicYears: [],
            currentSubjects: [],
            legacySubjects: [],
            yearWise: false,
            cached: true
        }
        this.errorsStatuses = {}
        this.userAcademicYears = []
        this.userCurrentSubjects = []
        this.usersAllCurrentBatchesAndSectionList = []
        this.usersLegacyAndCurrentBatchesAndSectionList = []
        this.userBatchesAndSection = { batches: [], sections: [] }

        makeObservable( this, {
            user: observable,
            userDebug: observable,
            userSubjects: observable,
            userAccounts: observable,
            errorsStatuses: observable,
            userAcademicYears: observable,
            userCurrentSubjects: observable,
            userBatchesAndSection: observable,
            usersAllCurrentBatchesAndSectionList: observable,
            usersLegacyAndCurrentBatchesAndSectionList: observable,

            setUser: action,
            fetchUser: action,
            fetchUsers: action,
            setUserDebug: action,
            capitalizeWords: action,
            fetchUserSubjects: action,
            setUserProfileImg: action,
            setERPSessionState: action,
            fetchUserAcademicYears: action,
            fetchUserBatchesAndSection: action,
            fetchUsersAllBatchesAndSectionList: action,

            getUser: computed,
            getUserDebug: computed,
            setUserAccounts: action,
            getUserAccounts: computed,
            getErrorsStatuses: computed,
            getUserAcademicYears: computed,
            getUserSubjectsDetails: computed,
            getUserBatchesAndSection: computed,
            getUsersAllBatchesAndSectionList: computed,
            getUsersLegacyAndCurrentBatchesAndSectionList: computed,
        } )
    }

    capitalizeWords = ( str ) => {
        if ( typeof str !== 'string' )
            return str
        return str.replace( /\w\S*/g, function ( txt ) { return txt.charAt( 0 ).toUpperCase() + txt.substring( 1 ).toLowerCase() } )
    }
    fetchUser = async ( forceSuppressUnAuthError = false ) => {
        //console.log(AuthStore.getToken)
        if ( AuthStore.getToken === null || AuthStore.isTokenExpired() ) {
            return { unauth: true, message: "Session does not exists!" }
        } else {
            try {
                const { data: { status, data } } = await this.api.getUser()
                if ( status && data ) {
                    if ( data?.user_source === "erp" && data?.session_data ) {
                        let erp_data = {
                            user_status: "active",
                            user_role: data?.user_role?.toUpperCase(),
                            user_id: data?.session_data?.user_id,
                            empcode: data?.session_data?.empcode,
                            section_short_name: data?.session_data?.section_short_name,
                            ac_year: data?.session_data?.ac_year,
                            user_dept_id: data?.session_data?.branch_id,
                            user_auditor: data?.session_data?.is_auditor,
                            current_sem: +data?.session_data?.current_sem,
                            data_sync_status: data?.data_sync_status || {},
                            current_year: +data?.session_data?.current_year,
                            user_dept_code: data?.session_data?.branch_name,
                            user_due_status: data?.session_data?.due_status,
                            branch: data?.session_data?.course_branch_short_name,
                            user_dept_code_short: data?.session_data?.branch_code,
                            user_org_code: data?.session_data?.institute_name_short,
                            user_profile: data?.session_data?.user_profile_image_url,
                            user_eligible_status: data?.session_data?.eligible_status,
                            user_name: this.capitalizeWords( data?.session_data?.username ),
                            user_auid: data?.session_data?.auid ? data?.session_data?.auid : '',
                            student_name: data?.session_data?.student_name,
                            employee_name: data?.session_data?.employee_name,
                            image_path: data?.session_data?.image_path,
                            email: data?.session_data?.email,
                            features_permissions: data.features_permissions,
                            name: data?.session_data?.student_name || data?.session_data?.employee_name || data?.session_data?.username
                        }
                        this.setUser( data ? erp_data : { "user_name": "", "user_email": "", "user_org_code": "", "user_dept_code": "" } )
                    } else if ( data?.user_source === "standalone" ) {
                        if ( data )
                            data.user_role = data?.user_role?.toUpperCase()
                        this.setUser( data ? data : { "user_name": "", "user_email": "", "user_org_code": "", "user_dept_code": "" } )
                    }
                }
                return { success: true, message: "User fetched successfully!" }
            } catch ( err ) {
                console.log( err )
                if ( err?.response?.status === 401 || err?.response?.data?.unauth || err?.response?.data?.unauth ) {
                    if ( !forceSuppressUnAuthError )
                        this.setERPSessionState( 'ended' )
                }
                if ( err.response )
                    return { netError: false, success: false, message: err?.message }
                return { netError: true, success: false, message: "User fetched successfully!" }

            }
        }

    }

    setERPSessionState = ( state ) => {
        AuthStore.setERPSessionState( state )
    }

    async setUserProfileImg ( payload ) {
        try {
            const { data: { data } } = await api.updateUserProfileImage( payload )
            runInAction( () => {
                this.user.user_profile = data
            } )
            return true
        } catch ( err ) {
            NotificationStore.setNotification( true, err?.response?.data?.message || "Something went wrong while updating profile image!" )
            return false
        }
    }

    fetchUserSubjects = async ( refresh = false ) => {
        try {
            const res = await this.api.getUserSubjects( { refresh } )
            if ( res.data.success ) {
                const subjectsDetails = {
                    years: new Set(),
                    semesters: new Set(),
                    academicYears: new Set(),
                    allSubjects: [],
                    currentSubjects: [],
                    legacySubjects: [],
                    yearWise: false,
                    cached: !refresh
                }

                const currentSubjects = structuredClone( res.data.data || {} )
                const legacySubjects = structuredClone( res.data.legacy_data || {} )
                if ( res.data.userRole === "STUDENT" ) {
                    const legacyYears = Object.keys( legacySubjects )
                    const currentYears = Object.keys( currentSubjects )
                    for ( const year of legacyYears.concat( currentYears ) ) {
                        subjectsDetails.years.add( year )
                    }

                    if ( currentYears.length > 0 && Array.isArray( currentSubjects[currentYears[0]] ) )
                        subjectsDetails.yearWise = true

                    if ( subjectsDetails.yearWise ) {
                        for ( const year of currentYears ) {
                            currentSubjects[year].forEach( sub => sub.legacy_subject = false )
                            subjectsDetails.allSubjects.push( ...currentSubjects[year] )
                            subjectsDetails.currentSubjects.push( ...currentSubjects[year] )
                        }
                    } else {
                        for ( const year of currentYears ) {
                            const sems = Object.keys( currentSubjects[year] || {} )
                            for ( const sem of sems ) {
                                subjectsDetails.semesters.add( sem )
                                const subjects = currentSubjects[year][sem]
                                subjects.forEach( sub => sub.legacy_subject = false )
                                subjectsDetails.allSubjects.push( ...subjects )
                                subjectsDetails.currentSubjects.push( ...subjects )
                            }
                        }
                    }

                    if ( legacyYears.length > 0 && Array.isArray( legacySubjects[legacyYears[0]] ) )
                        subjectsDetails.yearWise = true

                    if ( subjectsDetails.yearWise ) {
                        for ( const year of legacyYears ) {
                            const subjects = []
                            for ( const subs of legacySubjects[year] ) {
                                for ( const sub of subs ) {
                                    const exists = subjectsDetails.allSubjects.find( s => s.subject_code === sub.subject_code )
                                    if ( !exists ) {
                                        sub.legacy_subject = true
                                        subjects.push( sub )
                                    }
                                }

                            }
                            subjectsDetails.allSubjects.push( ...subjects )
                            subjectsDetails.legacySubjects.push( ...subjects )
                        }
                    } else {
                        for ( const year of legacyYears ) {
                            const sems = Object.keys( legacySubjects[year] || {} )
                            for ( const sem of sems ) {
                                subjectsDetails.semesters.add( sem )
                                const subjects = legacySubjects[year][sem]
                                for ( const subject of subjects ) {
                                    const exists = subjectsDetails.allSubjects.find( s => s.subject_code === subject.subject_code )
                                    if ( !exists ) {
                                        subject.legacy_subject = true
                                        subjectsDetails.allSubjects.push( subject )
                                    }
                                    subjectsDetails.legacySubjects.push( subject )
                                }
                            }
                        }
                    }
                    subjectsDetails.years = Array.from( subjectsDetails.years )
                    subjectsDetails.semesters = Array.from( subjectsDetails.semesters )
                    console.log( subjectsDetails )
                    runInAction( () => {
                        this.userSubjects = subjectsDetails
                        this.errorsStatuses.subjects = false
                    } )
                } else {
                    let uniqueSubs = [], uniqueIds = {}, uniqueCurrentSubs = []
                    for ( let i = currentSubjects.length - 1; i >= 0; i-- ) {
                        const sub = currentSubjects[i]
                        sub.unique_subject_key = `${sub.subject_code}-${sub.year}-${sub.sem}`
                        if ( !uniqueIds[sub.unique_subject_key] ) {
                            sub.legacy_subject = false
                            uniqueIds[sub.unique_subject_key] = true
                            subjectsDetails.allSubjects.push( sub )
                            subjectsDetails.currentSubjects.push( sub )
                            subjectsDetails.academicYears.add( sub.ac_year )
                        } else
                            console.log( "Duplicate Sub Found" )

                    }
                    for ( let i = legacySubjects.length - 1; i >= 0; i-- ) {
                        const sub = legacySubjects[i]
                        sub.legacy_subject = true
                        if ( !uniqueIds[sub.subject_code] ) {
                            uniqueIds[sub.subject_code] = true
                            subjectsDetails.allSubjects.splice( 0, 0, sub )
                            subjectsDetails.academicYears.add( sub.ac_year )
                        }
                        subjectsDetails.legacySubjects.push( sub )
                    }
                    subjectsDetails.academicYears = Array.from( subjectsDetails.academicYears ).sort( ( a, b ) => a > b ? -1 : 1 )
                    runInAction( () => {
                        this.userSubjects = subjectsDetails
                        this.errorsStatuses.subjects = false
                    } )
                }
                return true
            } else {
                runInAction( () => {
                    this.userSubjects = []
                    this.errorsStatuses.subjects = true
                } )
                return false
            }
        }
        catch ( err ) {
            runInAction( () => {
                this.userSubjects = []
                this.errorsStatuses.subjects = true
            } )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth || err?.response?.data?.unauth ) {
                this.setERPSessionState( 'ended' )
            }
            console.log( err )
            // return false
        }
    }

    fetchUserAcademicYears = async ( refresh = false ) => {
        try {
            const { data } = await this.api.getAllBatchAcademicYear( { refresh } )
            if ( data.success ) {
                runInAction( () => {
                    this.userAcademicYears = ( data.data || [] ).sort( ( a, b ) => b.ac_year_id - a.ac_year_id )
                    this.errorsStatuses.academicYears = false
                } )
                return true
            } else {
                runInAction( () => {
                    this.userAcademicYears = []
                    this.errorsStatuses.academicYears = true
                } )
                return false
            }
        } catch ( err ) {
            runInAction( () => {
                this.errorsStatuses.academicYears = true
            } )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth || err?.response?.data?.unauth ) {
                this.setERPSessionState( 'ended' )
            }
            console.log( err )
        }
    }

    fetchUserBatchesAndSection = async ( id, refresh = false ) => {
        try {
            const { data } = await this.api.getAllBatch( { ac_year_id: id, refresh } )
            if ( data.success ) {
                let allBatchesAndSectionsCopy = [...this.usersAllCurrentBatchesAndSectionList]
                const currentBatchesData = data?.data?.batches || []
                const currentSectionsData = data?.data?.sections || []
                currentBatchesData.forEach( batch => {
                    if ( !batch.course_name_short )
                        batch.course_name_short = batch.course_short_name
                    batch.id = batch.batch_assignment_id
                    batch.ac_year_id = id
                    batch.ac_year = this.userAcademicYears.find( ay => ay.ac_year_id === id )?.ac_year
                    batch.entity = 'batch'
                    batch.title = `${batch.batch_name}-${Array.from( new Set( batch.course_name_short?.split( "," ) ) ).join( ", " ) || ""}${batch.current_year ? ` Y${batch.current_year}` : ``}${batch.current_sem ? ` S${batch.current_sem}` : ``} ${batch.batch_short_name}`
                    batch.short_title = `Batch ${batch.batch_name}${batch.remarks ? `, ${batch.remarks}` : "Remarks: Not given."}`
                    batch.chip_label = `Batch: ${batch.batch_name}${batch.remarks ? `, ${batch.remarks}` : "Remarks: Not given."}`
                    batch.academic_details = `${batch.ac_year}, ${batch.current_year ? `Year: ${batch.current_year}` : ""}${batch.current_sem ? `, Semester: ${batch.current_sem}` : ""}, Remarks: ${batch.remarks || "Not given."}`
                    batch.course_name_short = Array.from( new Set( batch.course_name_short?.split( "," ) ) ).join( ", " )
                } )
                currentSectionsData.forEach( section => {
                    section.id = `${section.section_assignment_id}-${section.section_short_name}`
                    section.entity = 'section'
                    section.ac_year_id = id
                    section.ac_year = this.userAcademicYears.find( ay => ay.ac_year_id === id )?.ac_year
                    section.title = `${section.course_branch_short_name}-${section.course_short_name || ""}${section.current_year ? ` Y${section.current_year}` : ``}${section.current_sem ? ` S${section.current_sem}` : ``} (${section.section_short_name + ")"}`
                    section.short_title = `Section ${section.section_short_name}`
                    section.chip_label = `Section: ${section.section_short_name} `
                    section.academic_details = `${section.ac_year}, ${section.current_year ? `Year: ${section.current_year}` : ""}${section.current_sem ? `, Semester: ${section.current_sem}` : ""}, Remarks: ${section.remarks || "Not given."}`
                    section.course_name_short = section.course_short_name
                } )
                allBatchesAndSectionsCopy = allBatchesAndSectionsCopy.filter( item => +item.ac_year_id !== +id )
                allBatchesAndSectionsCopy.push( ...( currentBatchesData || [] ), ...( currentSectionsData || [] ) )

                runInAction( () => {
                    this.usersAllCurrentBatchesAndSectionList = allBatchesAndSectionsCopy
                    this.userBatchesAndSection = data.data
                    this.errorsStatuses.academicYearBatch = false
                } )
                return true
            } else {
                runInAction( () => {
                    this.userBatchesAndSection = { batches: [], sections: [] }
                    this.errorsStatuses.academicYearBatch = true
                } )
                return false
            }
        } catch ( err ) {
            runInAction( () => {
                this.errorsStatuses.academicYearBatch = true
            } )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth || err?.response?.data?.unauth ) {
                this.setERPSessionState( 'ended' )
            }
            console.log( err )
        }
    }

    fetchUsersAllBatchesAndSectionList = async ( refresh = false ) => {
        try {
            const { data } = await this.api.getUserAllBatchesAndSections()
            const allBatchesAndSectionslist = []
            const currentBatchesAndSectionslist = []

            const currentBatchesData = data?.data?.batches || []
            const currentSectionsData = data?.data?.sections || []

            const legacyBatchesData = data?.legacy_data?.batches || []
            const legacySectionsData = data?.legacy_data?.sections || []

            currentBatchesData.forEach( batch => {
                if ( !batch.course_name_short )
                    batch.course_name_short = batch.course_short_name
                batch.id = batch.batch_assignment_id
                batch.entity = 'batch'
                batch.title = `${batch.batch_name}-${batch.course_name_short || ""}${batch.current_year ? ` Y${batch.current_year}` : ``}${batch.current_sem ? ` S${batch.current_sem}` : ``} ${batch.batch_short_name}`
                batch.short_title = `Batch ${batch.batch_name}${batch.remarks ? `, ${batch.remarks}` : "Remarks: Not given."}`
                batch.chip_label = `Batch: ${batch.batch_name}${batch.remarks ? `, ${batch.remarks}` : "Remarks: Not given."}`
                batch.academic_details = `${batch.ac_year}, ${batch.current_year ? `Year: ${batch.current_year}` : ""}${batch.current_sem ? `, Semester: ${batch.current_sem}` : ""}, Remarks: ${batch.remarks || "Not given."}`
                batch.course_name_short = Array.from( new Set( batch.course_name_short?.split( "," ) ) ).join( ", " )
            } )
            currentSectionsData.forEach( section => {
                section.id = `${section.section_assignment_id}-${section.section_short_name}`
                section.entity = 'section'
                section.title = `${section.course_branch_short_name}-${section.course_short_name || ""}${section.current_year ? ` Y${section.current_year}` : ``}${section.current_sem ? ` S${section.current_sem}` : ``} (${section.section_short_name + ")"}`
                section.short_title = `Section ${section.section_short_name}`
                section.chip_label = `Section: ${section.section_short_name} `
                section.academic_details = `${section.ac_year}, ${section.current_year ? `Year: ${section.current_year}` : ""}${section.current_sem ? `, Semester: ${section.current_sem}` : ""}, Remarks: ${section.remarks || "Not given."}`
                section.course_name_short = section.course_short_name
            } )

            legacyBatchesData.forEach( batch => {
                if ( !batch.course_name_short )
                    batch.course_name_short = batch.course_short_name
                batch.id = batch.batch_assignment_id
                batch.entity = 'batch'
                batch.title = `${batch.batch_name}-${batch.course_name_short || ""}${batch.current_year ? ` Y${batch.current_year}` : ``}${batch.current_sem ? ` S${batch.current_sem}` : ``} ${batch.batch_short_name}`
                batch.short_title = `Batch ${batch.batch_name}${batch.remarks ? `, ${batch.remarks}` : "Remarks: Not given."}`
                batch.chip_label = `Batch: ${batch.batch_name}${batch.remarks ? `, ${batch.remarks}` : "Remarks: Not given."}`
                batch.academic_details = `${batch.ac_year}, ${batch.current_year ? `Year: ${batch.current_year}` : ""}${batch.current_sem ? `, Semester: ${batch.current_sem}` : ""}, Remarks: ${batch.remarks || "Not given."}`
                batch.course_name_short = Array.from( new Set( batch.course_name_short?.split( "," ) ) ).join( ", " )
            } )
            legacySectionsData.forEach( section => {
                section.id = `${section.section_assignment_id}-${section.section_short_name}`
                section.entity = 'section'
                section.title = `${section.course_branch_short_name}-${section.course_short_name || ""}${section.current_year ? ` Y${section.current_year}` : ``}${section.current_sem ? ` S${section.current_sem}` : ``} (${section.section_short_name + ")"}`
                section.short_title = `Section ${section.section_short_name}`
                section.chip_label = `Section: ${section.section_short_name} `
                section.academic_details = `${section.ac_year}, ${section.current_year ? `Year: ${section.current_year}` : ""}${section.current_sem ? `, Semester: ${section.current_sem}` : ""}, Remarks: ${section.remarks || "Not given."}`
                section.course_name_short = section.course_short_name
            } )

            allBatchesAndSectionslist.push( ...legacySectionsData, ...legacySectionsData )
            allBatchesAndSectionslist.push( ...currentBatchesData, ...currentSectionsData )
            currentBatchesAndSectionslist.push( ...currentBatchesData, ...currentSectionsData )

            runInAction( () => {
                this.usersAllCurrentBatchesAndSectionList = currentBatchesAndSectionslist
                this.usersLegacyAndCurrentBatchesAndSectionList = allBatchesAndSectionslist
                this.errorsStatuses.academicYearsAndBatches = false
                this.userAcademicYears = data.data.academic_years?.sort( ( a, b ) => b.ac_year_id - a.ac_year_id )
                this.errorsStatuses.academicYears = false
            } )
        } catch ( err ) {
            runInAction( () => {
                this.errorsStatuses.academicYearsAndBatches = true
                this.errorsStatuses.academicYears = true
            } )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth || err?.response?.data?.unauth ) {
                this.setERPSessionState( 'ended' )
            }
            console.log( err )
        }
    }

    fetchUsers = async () => {
        ///console.log(AuthStore.isTokenExpired())
        if ( AuthStore.getToken === null || AuthStore.isTokenExpired() ) {
            console.log( "Session Do not exist!" )
        } else {
            try {
                const res = await this.api.getUsers()
                //console.log(res)
                this.setUserAccounts( res["data"]["data"] )
            } catch ( err ) {
                console.log( err )
            }
        }

    }

    // get compute_func()
    get getUser () {
        return toJS( this.user )
    }

    get getUserAcademicYears () {
        return toJS( this.userAcademicYears )
    }

    get getUserBatchesAndSection () {
        return toJS( this.userBatchesAndSection )
    }

    get getUsersAllBatchesAndSectionList () {
        return toJS( this.usersAllCurrentBatchesAndSectionList )
    }

    get getUsersLegacyAndCurrentBatchesAndSectionList () {
        return toJS( this.usersLegacyAndCurrentBatchesAndSectionList )
    }

    setUser ( user ) {
        this.user = user
    }

    get getUserAccounts () {
        return toJS( this.userAccounts )
    }

    get getUserSubjectsDetails () {
        const subjects = toJS( this.userSubjects )
        return subjects
    }

    get getErrorsStatuses () {
        return toJS( this.errorsStatuses )
    }

    setUserAccounts ( userAccounts ) {
        this.userAccounts = userAccounts
    }

    createUserAccount = async ( payload ) => {
        try {
            const res = await this.api.createUser( payload )
            console.log( res )
        } catch ( error ) {

        }
    }

    updateUserStatus = async ( payload ) => {

        await this.api.updateUserStatus( payload )
        this.fetchUsers()

    }

    updatePassword = async ( payload ) => {
        try {
            const res = await this.api.updatePassword( payload )
            console.log( res["data"]["message"] )
        } catch ( err ) {

        }
    }

    get getUserDebug () {
        return toJS( this.userDebug )
    }

    setUserDebug = ( data ) => {
        this.userDebug = data
    }

    userDebugTimetable = async ( payload ) => {
        return await this.api.findUserDebugTimetable( payload )
        // .then((res)=>{
        //     console.log(`User Debug : `, res["data"])
        // }).catch((err)=>{

        // })
    }

}

const UserStoreInstance = new UserStore()

export default UserStoreInstance

const UserStoreContext = React.createContext()

export const UserStoreProvider = ( { children, store } ) => {
    return (
        <UserStoreContext.Provider value={store}>{children}</UserStoreContext.Provider>
    )
}

/* Hook to use store in any functional component */
export const useUserStore = () => React.useContext( UserStoreContext )